import type { RouteRecordRaw } from "vue-router";

const dashboardRouter: RouteRecordRaw[] = [
    {
        path: "/dashboard",
        name: "Dashboard",
        component: () => import("@/layouts/index.vue"),
        meta: {
            title: "运营分析"
        },
        children: [
            {
                path: "/dashboard/index",
                name: "DashboardIndex",
                component: () => import("@/views/pages/dashboard/index.vue"),
                meta: {
                    title: "用户看板",
                    isNotShowHeader: true,
                    authOptions: [
                        {
                            label: "砂石交易看板-查看",
                            value: "ROLE_DEAL_BI"
                        },
                        {
                            label: "链云用户看板-查看",
                            value: "ROLE_USER_BI"
                        },
                        {
                            label: "物流看板-查看",
                            value: "ROLE_SHIP_BI"
                        }
                    ]
                }
            },
            {
                path: "goodsOperationAnalysis",
                name: "GoodsOperationAnalysis",
                component: () =>
                    import("@/views/pages/dashboard/lianyunOperationAnalysis/goodsOperationAnalysis/index.vue"),
                meta: {
                    title: "商品运营",
                    isNotShowHeader: true,
                    authOptions: [
                        {
                            label: "商品运营-查看",
                            value: "ROLE_SAND_PRODUCT_BI_R"
                        }
                    ]
                }
            },
            {
                path: "consignmentGoodsAnalysisDetail",
                name: "ConsignmentGoodsAnalysisDetail",
                component: () =>
                    import("@/views/pages/dashboard/lianyunOperationAnalysis/consignmentGoodsAnalysisDetail/index.vue"),
                meta: {
                    title: "商品运营详情",
                    isNotShowHeader: true,
                    hidden: true,
                    activeMenu: "GoodsOperationAnalysis",
                    authOptions: [
                        {
                            label: "商品运营详情-查看",
                            value: "ROLE_SAND_PRODUCT_BI_R"
                        }
                    ]
                }
            },
            {
                path: "functionalOperationAnalysis",
                name: "FunctionalOperationAnalysis",
                component: () =>
                    import("@/views/pages/dashboard/lianyunOperationAnalysis/functionalOperationAnalysis/index.vue"),
                meta: {
                    title: "用户行为",
                    isNotShowHeader: true,
                    authOptions: [
                        {
                            label: "用户行为-查看",
                            value: "ROLE_SAND_FUNCTION_BI_R"
                        }
                    ]
                }
            }
        ]
    }
];

export default dashboardRouter;
